import { render, staticRenderFns } from "./Introduction.vue?vue&type=template&id=58dc161d&scoped=true"
import script from "./Introduction.vue?vue&type=script&lang=ts"
export * from "./Introduction.vue?vue&type=script&lang=ts"
import style0 from "./Introduction.vue?vue&type=style&index=0&id=58dc161d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dc161d",
  null
  
)

export default component.exports